<div class="filtering-chips" *ngIf="hasActiveChips">
  <mat-chip-set class="filtering-chips__list">
    <mat-chip *ngIf="hasEntityChip(displaysTextMap.customerName)" class="filter-chip">
      <span class="filter-chip__label">{{ "Filter.Form.Customer" | translate }}:</span>
      <span class="filter-chip__value" [matTooltip]="displaysDetails.customerName">{{ displaysTextMap.customerName }}</span>
      <span class="filter-chip__more" *ngIf="displaysExtraMap.customerName">{{ displaysExtraMap.customerName }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ customerId: null, offset: 0 }, { customerName: null }, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="hasEntityChip(displaysTextMap.receiverName)" class="filter-chip">
      <span class="filter-chip__label">{{ "Filter.Form.Receiver" | translate }}:</span>
      <span class="filter-chip__value" [matTooltip]="displaysDetails.receiverName">{{ displaysTextMap.receiverName }}</span>
      <span class="filter-chip__more" *ngIf="displaysExtraMap.receiverName">{{ displaysExtraMap.receiverName }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ receiverId: null, offset: 0 }, { receiverName: null }, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="hasEntityChip(displaysTextMap.fleetName)" class="filter-chip">
      <span class="filter-chip__label">{{ "Filter.Form.Fleet" | translate }}:</span>
      <span class="filter-chip__value" [matTooltip]="displaysDetails.fleetName">{{ displaysTextMap.fleetName }}</span>
      <span class="filter-chip__more" *ngIf="displaysExtraMap.fleetName">{{ displaysExtraMap.fleetName }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ fleetId: null, offset: 0 }, { fleetName: null }, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="hasIdChip(params?.truckId, displaysTextMap.truckName)" class="filter-chip">
      <span class="filter-chip__label">{{ "Shipments.Truck" | translate }}:</span>
      <span class="filter-chip__value" [matTooltip]="displaysDetails.truckName">{{ displaysTextMap.truckName }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ truckId: null, offset: 0 }, { truckName: null }, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="hasIdChip(params?.driverId, displaysTextMap.driverName)" class="filter-chip">
      <span class="filter-chip__label">{{ "Shipments.Driver" | translate }}:</span>
      <span class="filter-chip__value" [matTooltip]="displaysDetails.driverName">{{ displaysTextMap.driverName }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ driverId: null, offset: 0 }, { driverName: null }, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="hasEntityChip(displaysTextMap.creatorName)" class="filter-chip">
      <span class="filter-chip__label">{{ "Filter.Form.Creator" | translate }}:</span>
      <span class="filter-chip__value" [matTooltip]="displaysDetails.creatorName">{{ displaysTextMap?.creatorName }}</span>
      <span class="filter-chip__more" *ngIf="displaysExtraMap.creatorName">{{ displaysExtraMap.creatorName }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ creator: null, offset: 0 }, { creatorName: null }, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="hasEntityChip(displaysTextMap.fromCityName)" class="filter-chip">
      <span class="filter-chip__label">{{ "Filter.Form.PickupLocation" | translate }}:</span>
      <span class="filter-chip__value" [matTooltip]="displaysDetails.fromCityName">{{ displaysTextMap.fromCityName }}</span>
      <span class="filter-chip__more" *ngIf="displaysExtraMap.fromCityName">{{ displaysExtraMap.fromCityName }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ fromCityId: null, offset: 0 }, { fromCityName: null }, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="hasEntityChip(displaysTextMap.toCityName)" class="filter-chip">
      <span class="filter-chip__label">{{ "Filter.Form.DropOffLocation" | translate }}:</span>
      <span class="filter-chip__value" [matTooltip]="displaysDetails.toCityName">{{ displaysTextMap.toCityName }}</span>
      <span class="filter-chip__more" *ngIf="displaysExtraMap.toCityName">{{ displaysExtraMap.toCityName }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ toCityId: null, offset: 0 }, { toCityName: null }, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="statusLabel(params?.status) as statusKey" class="filter-chip">
      <span class="filter-chip__label">{{ "Filter.Form.Status" | translate }}:</span>
      <span class="filter-chip__value">{{ statusKey | translate }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ status: resetStatus, offset: 0 }, null, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="customerServiceTypeLabel(params?.customerServiceType) as serviceTypeKey" class="filter-chip">
      <span class="filter-chip__label">{{ "shipments.CustomerType" | translate }}:</span>
      <span class="filter-chip__value">{{ serviceTypeKey | translate }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ customerServiceType: null, offset: 0 }, null, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="bayanLabel(params?.isBayanVerified) as bayanKey" class="filter-chip">
      <span class="filter-chip__label">{{ "shipments.BayanIntegration" | translate }}:</span>
      <span class="filter-chip__value">{{ bayanKey | translate }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ isBayanVerified: null, offset: 0 }, null, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="tripTypeLabel(params?.shipmentRequestFilterCount) as tripTypeKey" class="filter-chip">
      <span class="filter-chip__label">{{ "shipments.TripType" | translate }}:</span>
      <span class="filter-chip__value">{{ tripTypeKey | translate }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ shipmentRequestFilterCount: null, offset: 0 }, null, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="trackingLabel(params?.trackingTypeFilter) as trackingKey" class="filter-chip">
      <span class="filter-chip__label">{{ "shipments.TrackingBy" | translate }}:</span>
      <span class="filter-chip__value">{{ trackingKey | translate }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ trackingTypeFilter: resetTrackingType, offset: 0 }, null, true])"></app-icon>
    </mat-chip>

    <mat-chip *ngIf="directionLabel(params?.direction) as directionKey" class="filter-chip">
      <span class="filter-chip__label">{{ "shipments.Direction" | translate }}:</span>
      <span class="filter-chip__value">{{ directionKey | translate }}</span>
      <app-icon name="outline-cross" size="xxs" matChipRemove
        (click)="updateParams.emit([{ direction: null, offset: 0 }, null, true])"></app-icon>
    </mat-chip>
  </mat-chip-set>

  <a class="small py-1 px-2 weight-medium text-warn nowrap cursor-pointer" (click)="clearAll()">{{ "Filter.ClearAll" | translate }}</a>
</div>
